import React from 'react';

const InputGroup = ({ label, type = "text", placeholder, value, onChange, required, step }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-xs font-semibold text-[#44474c]">{label}</label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      step={step}
      className="bg-[#f2f4f7] border-none rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-[#041627]/10"
    />
  </div>
);

export default InputGroup;